import { render, staticRenderFns } from "./InfoText.vue?vue&type=template&id=67130be1&scoped=true&"
import script from "./InfoText.vue?vue&type=script&lang=js&"
export * from "./InfoText.vue?vue&type=script&lang=js&"
import style0 from "./InfoText.vue?vue&type=style&index=0&id=67130be1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67130be1",
  null
  
)

export default component.exports